import { useEffect, useState } from 'react';
import { BuildPath } from  '@/helpers/Paths';
import { WidgetType } from  '@/interfaces/widgetPanel';


export const UseWidgetButton = (widgetType: WidgetType) => {
    const [widgetTitle, setWidgetTitle] = useState("");
    const [widgetImageUrl, setWidgetImageUrl] = useState(""); 
    const [widgetImageAlt, setWidgetImageAlt] = useState(""); 

    useEffect(()=> {
        if (widgetType) {
            setWidgetVariables(widgetType);
        }
    }, [widgetType]);

    
    function setWidgetVariables(widget: WidgetType) {
        switch (widget) {
            case WidgetType.TEXT: 
                setWidgetTitle("Text");
                setWidgetImageUrl(`${BuildPath()}/images/content-types/text_icon.svg`);
                setWidgetImageAlt(`Text box`);
                break;

            case WidgetType.IMAGE: 
                setWidgetTitle("Image");
                setWidgetImageUrl(`${BuildPath()}/images/content-types/image_icon.svg`);
                setWidgetImageAlt(`Image viewer`);
                break;

            case WidgetType.VIDEO: 
                setWidgetTitle("Video");
                setWidgetImageUrl(`${BuildPath()}/images/content-types/video_icon.svg`);
                setWidgetImageAlt(`Video Player`);
                break;

            case WidgetType.AUDIO: 
                setWidgetTitle("Audio");
                setWidgetImageUrl(`${BuildPath()}/images/content-types/audio_icon.svg`);
                setWidgetImageAlt(`Music Player`);
                break;
            
            case WidgetType.FILE: 
                setWidgetTitle("File");
                setWidgetImageUrl(`${BuildPath()}/images/content-types/file_icon.svg`);
                setWidgetImageAlt(`Text in file`);
                break;
            
            case WidgetType.WEB_EMBED:
                setWidgetTitle("Web Embed");
                setWidgetImageUrl(`${BuildPath()}/images/content-types/html_icon.svg`);
                setWidgetImageAlt(`Code in File`);
                break;

            case WidgetType.WEB_PAGE: 
                setWidgetTitle("Web Page");
                setWidgetImageUrl(`${BuildPath()}/images/content-types/html_icon.svg`);
                setWidgetImageAlt(`Code in File`);
                break;

            case WidgetType.EXISTING: 
                setWidgetTitle("Existing");
                setWidgetImageUrl(`${BuildPath()}/images/content-types/existing_icon.svg`);
                setWidgetImageAlt(`document with link`);
                break;

            case WidgetType.YOUTUBE: 
                setWidgetTitle("YouTube");
                setWidgetImageUrl(`${BuildPath()}/images/htmlIcons/logo-youtube.svg`);
                setWidgetImageAlt(`YouTube Play Button`);
                break;

            case WidgetType.VIMEO: 
                setWidgetTitle("Vimeo");
                setWidgetImageUrl(`${BuildPath()}/images/htmlIcons/logo-vimeo.svg`);
                setWidgetImageAlt(`Blue Vimeo Brand`);
                break;

            case WidgetType.GIPHY: 
                setWidgetTitle("Giphy");
                setWidgetImageUrl(`${BuildPath()}/images/htmlIcons/logo-giphy.svg`);
                setWidgetImageAlt(`Giphy File`);
                break;

            case WidgetType.GOOGLE_MAPS: 
                setWidgetTitle("Google Maps");
                setWidgetImageUrl(`${BuildPath()}/images/htmlIcons/logo-google-maps.svg`);
                setWidgetImageAlt(`Map Pin with blue, green, red and yellow`);
                break;

            case WidgetType.HTML: 
                setWidgetTitle("HTML");
                setWidgetImageUrl(`${BuildPath()}/images/htmlIcons/logo-code.svg`);
                setWidgetImageAlt(`Code snippet`);
                break;
            case WidgetType.LIST: 
                setWidgetTitle("List");
                setWidgetImageUrl(`${BuildPath()}/images/content-types/list_icon.svg`);
                setWidgetImageAlt(`Clipboard with a list`);
                break;
            case WidgetType.PAGE: 
                setWidgetTitle("Page");
                setWidgetImageUrl(`${BuildPath()}/images/content-types/page_icon.svg`);
                setWidgetImageAlt(`Page with upturned corner and some placeholder skeleton content`);
                break;
            case WidgetType.RSS: 
                setWidgetTitle("RSS");
                setWidgetImageUrl(`${BuildPath()}/images/content-types/rss_icon.svg`);
                setWidgetImageAlt(`Browser window with an RSS icon in it`);
                break;
            case WidgetType.CONTACT: 
                setWidgetTitle("Contact");
                setWidgetImageUrl(`${BuildPath()}/images/content-types/contact_icon.svg`);
                setWidgetImageAlt(`Business card`);
                break;
            case WidgetType.COMBINED_FEED: 
                setWidgetTitle("Combined Feed");
                setWidgetImageUrl(`${BuildPath()}/images/content-types/combinedFeed_icon.svg`);
                setWidgetImageAlt(`List of Feed items`);
                break;
            case WidgetType.DUPLICATE: 
                setWidgetTitle("Duplicate");
                setWidgetImageUrl(`${BuildPath()}/images/content-types/duplicate_content.svg`);
                setWidgetImageAlt(`Document with plus icon`);
                break;
            default:
            return;
        }
    }
    
    return {widgetTitle, widgetImageUrl, widgetImageAlt};
};
